module.exports = __webpack_public_path__ + "static/media/quizBoard.fe880b5a.svg";